var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhyC2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_226",
    "data-name": "Group 226",
    xmlns: "http://www.w3.org/2000/svg",
    width: 173.412,
    height: 173.412,
    viewBox: "0 0 173.412 173.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M162.936,77.9V98.221a3.387,3.387,0,0,0,.992,2.395l6.774,6.774a3.388,3.388,0,0,0,2.395.992h20.322a3.388,3.388,0,0,0,2.395-.992l6.774-6.774a3.387,3.387,0,0,0,.992-2.395V77.9c0-5.185.345-6.3,9.323-18.075a36.921,36.921,0,0,0,7.612-22.568,37.256,37.256,0,0,0-74.513,0,36.919,36.919,0,0,0,7.612,22.568C162.59,71.6,162.936,72.715,162.936,77.9Zm33.869,3.387v6.774h-27.1V81.287Zm-4.79,20.322H174.5l-4.79-4.79V94.834h27.1v1.984ZM183.257,6.774A30.517,30.517,0,0,1,213.74,37.256a30.2,30.2,0,0,1-6.225,18.461c-7.6,9.965-9.976,13.505-10.553,18.8H186.644V45.433l5.782-5.782a3.387,3.387,0,0,0-4.79-4.79l-4.379,4.379-4.379-4.379a3.387,3.387,0,0,0-4.79,4.79l5.782,5.782V74.513H169.552c-.577-5.29-2.955-8.831-10.553-18.8a30.2,30.2,0,0,1-6.225-18.461A30.518,30.518,0,0,1,183.257,6.774Z",
    transform: "translate(-96.552 0)",
    fill: "#170d65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M84.388,106.774h6.774a3.387,3.387,0,1,0,0-6.774H84.388a3.387,3.387,0,1,0,0,6.774Z",
    transform: "translate(-53.567 -66.131)",
    fill: "#170d65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M104.8,23.819l5.866,3.387a3.387,3.387,0,1,0,3.387-5.866l-5.866-3.387a3.387,3.387,0,0,0-3.387,5.866Z",
    transform: "translate(-68.184 -11.572)",
    fill: "#170d65"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M110.666,172.953,104.8,176.34a3.387,3.387,0,1,0,3.387,5.866l5.866-3.387a3.387,3.387,0,1,0-3.387-5.866Z",
    transform: "translate(-68.184 -114.074)",
    fill: "#170d65"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M391,103.387a3.387,3.387,0,0,0,3.387,3.387h6.774a3.387,3.387,0,1,0,0-6.774h-6.774A3.387,3.387,0,0,0,391,103.387Z",
    transform: "translate(-258.571 -66.131)",
    fill: "#170d65"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M374.964,27.661a3.371,3.371,0,0,0,1.69-.455l5.866-3.387a3.387,3.387,0,1,0-3.387-5.866l-5.866,3.387a3.387,3.387,0,0,0,1.7,6.321Z",
    transform: "translate(-245.724 -11.572)",
    fill: "#170d65"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M373.267,178.819l5.866,3.387a3.387,3.387,0,0,0,3.387-5.866l-5.866-3.387a3.387,3.387,0,1,0-3.387,5.866Z",
    transform: "translate(-245.724 -114.074)",
    fill: "#170d65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M170.026,369.11V358.695a3.387,3.387,0,0,0-3.387-3.387c-13.628,0-22.138-3.913-29.647-7.366-2.193-1.009-4.265-1.961-6.339-2.754-9.961-3.81-19.023-4.184-26.935-1.112-6.451,2.5-12.156,7.32-17.012,14.345-4.856-7.025-10.561-11.84-17.012-14.345-7.911-3.072-16.974-2.7-26.935,1.112-2.074.793-4.145,1.746-6.339,2.754-7.508,3.453-16.018,7.366-29.647,7.366a3.387,3.387,0,0,0-3.387,3.387V369.11A3.387,3.387,0,0,0,0,372.5v15.241a3.387,3.387,0,0,0,3.387,3.387H73.055a15.239,15.239,0,0,0,27.3,0h69.667a3.387,3.387,0,0,0,3.387-3.387V372.5a3.387,3.387,0,0,0-3.387-3.387Zm-41.793-17.6c1.866.714,3.839,1.621,5.929,2.582,7.142,3.284,15.9,7.31,29.09,7.909v7.1H98.271a17.843,17.843,0,0,0-8.177,1.784v-5.179C99.344,349.885,111.828,345.241,128.233,351.515ZM39.252,354.1c2.089-.961,4.063-1.868,5.929-2.581,16.405-6.274,28.889-1.629,38.14,14.2v5.179a17.841,17.841,0,0,0-8.177-1.784H10.162v-7.1c13.192-.6,21.948-4.625,29.09-7.909Zm127.387,30.255H98.069a3.387,3.387,0,0,0-3.246,2.42,8.471,8.471,0,0,1-16.233,0,3.387,3.387,0,0,0-3.246-2.42H6.775v-8.467H75.143c4.1,0,6.838,1.446,8.63,4.551a3.387,3.387,0,0,0,5.866,0c1.793-3.1,4.535-4.551,8.63-4.551h68.368v8.467Z",
    transform: "translate(-0.001 -226.181)",
    fill: "#170d65"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyC2);
export default __webpack_public_path__ + "static/media/whyC2.a639bfcf8a90fb6af57e836152ef77d8.svg";
export { ForwardRef as ReactComponent };